<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-2 tw-right-2 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon class="tw-text-white">close</mat-icon>
  </button>

  <div
    mat-dialog-title
    class="!tw-flex tw-items-center !tw-pt-2 !tw-text-white !tw-bg-yellow-500"
    [ngClass]="titleClass"
  >
    <mat-icon class="tw-text-[3rem] !tw-h-12 !tw-w-12 tw-mr-4 matp-fill-icon">
      error
    </mat-icon>
    <span class="tw-text-[2rem]">{{ title }}</span>
  </div>

  <mat-dialog-content
    class="!tw-flex tw-flex-col tw-gap-8 tw-w-full tw-whitespace-pre-wrap !tw-text-xl !tw-p-8 !tw-pb-12"
  >
    <span>{{ message }}</span>

    <div class="matp-table-area">
      <table
        mat-table
        matSort
        matSortActive="csvNo"
        matSortDirection="asc"
        [dataSource]="dataSource"
        id="device-import-error-table"
        class="matp-table"
      >
        <!-- csvファイルの行番号 -->
        <ng-container matColumnDef="csvNo">
          <th mat-header-cell *matHeaderCellDef class="!tw-py-1">
            <div mat-sort-header class="tw-flex matp-table-header-title">
              行番号
            </div>
          </th>
          <td name="csvNo" mat-cell *matCellDef="let element">
            {{ element.csvNo }}
          </td>
        </ng-container>

        <!-- シリアル番号 -->
        <ng-container matColumnDef="serialNo">
          <th mat-header-cell *matHeaderCellDef class="!tw-py-1">
            <div mat-sort-header class="tw-flex matp-table-header-title">
              シリアル番号
            </div>
          </th>
          <td name="serialNo" mat-cell *matCellDef="let element">
            {{ element.serialNo }}
          </td>
        </ng-container>

        <!-- 登録失敗理由 -->
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef class="!tw-py-1">
            <div mat-sort-header class="tw-flex matp-table-header-title">
              登録失敗理由
            </div>
          </th>
          <td name="message" mat-cell *matCellDef="let element">
            {{ element.message }}
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="!tw-pb-5">
    <button
      mat-raised-button
      mat-dialog-close
      class="!tw-min-w-40 tw-my-0 tw-mx-3"
    >
      <mat-icon>close</mat-icon>
      {{ operation ? "キャンセル" : "閉じる" }}
    </button>

    <button
      *ngIf="operation"
      mat-raised-button
      class="!tw-min-w-40 tw-my-0 tw-mx-3"
      (click)="doOperation()"
    >
      <mat-icon>done</mat-icon>
      {{ operation }}
    </button>
  </mat-dialog-actions>
</div>
